<template>
  <div>
    <span v-if="productMainView == 'cartactions'" >
      <button v-if="canAdd" class="cart-btn cart-btn-sm" @click="addToCart">Add to Cart</button>
      <div v-else>
        <div class="hidden-sm hidden-xs">
          <div class="cart-cta-box">
            <!-- <li> <a class="cart-btn btn-white remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</a></li> -->
            <button  class="cart-btn cart-btn-sm" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
            <!-- <li style="margin-top: 2em;"> <a  class="cart-btn btn-white btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</a></li> -->
          </div>
        </div>
        <div class="hidden-md hidden-lg">
          <!-- <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</button> -->
          <button style="line-height:2em" class="cart-btn cart-btn-sm" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
          <!-- <button style="line-height:2em" class="cart-btn btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</button>  -->
        </div>
      </div>
    </span>
    <div v-else style="clear:right; float:right">
      <button v-if="canAdd" class="cart-btn" @click="addToCart">Add to Cart</button>
      <div v-else>
        <div class="hidden-sm hidden-xs">
          <div class="cart-cta-box">
            <li> <a class="cart-btn btn-white remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</a></li>
            <li> <a  class="cart-btn btn-black view-btn" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</a></li>
            <li style="margin-top: 2em;"> <a  class="cart-btn btn-white btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</a></li>
          </div>
        </div>
      <div class="hidden-md hidden-lg">
        <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</button>
        <button style="line-height:2em" class="cart-btn view-btn" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
        <button style="line-height:2em" class="cart-btn btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</button> 
      </div>
        <!-- <button style="background:#e05024" class="cart-btn remove-btn" @click="removeFromCart(productItem)"><i class="fa fa-trash"></i> Remove from Cart</button>
        <button style="line-height:2em" class="cart-btn view-btn" @click="redir('cart')"><i class="fa fa-shopping-cart"></i> View Cart</button>
        <button style="line-height:2em" class="cart-btn btn-primary" @click="redir('')"><i class="fa fa-shopping-cart"></i> Continue Shopping</button> -->
      </div>
    </div>
  </div>
</template>
<style>
  .cart-cta-box li{
    /* display: inline; */
  }
  .cart-cta-box a{
    /* display: inline; */
    cursor: pointer;
    line-height: 1em;
    margin-bottom: 2em;
    /* color: inherit; */
    text-decoration: none;
  }
  .btn-white:hover{
    color: #ffffff;
  }
  .btn-black:hover{
    color: #000000;
  }
  .cart-btn-sm{
    /* line-height: 1.2; */
    font-size: 12px;
  }
 .cart-btn{
   width: 100%;
    border: none;
    border-radius: 3px;
    box-shadow: none;
    white-space: nowrap;
    color: #ffffff;
    padding: 10px 30px;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    background: #ffa800;
    /* background: #ee992b; */
    /* background: #ffc13b; */
    letter-spacing: 1px;
    position: relative;
    text-align: center;
    z-index: 1;
 }

 .remove-btn{
   background: #ee2b2b;
 }

  .view-btn{
    background: #dde3e9;
    color:#000000;
  }

 @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 640px){
    .cart-btn{
      padding: 10px 10px;
      width: 100%;
    }
  }
</style>
<script>
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'
  export default {
    props: ['productMain','productItemGroup','productItem','productMainView'],
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    computed: {
      canAdd () {
        // return this.cart.indexOf(this.productItem) < 0
        const index = this.cart.findIndex(p => p.product_item_id === this.productItem.product_item_id) //best removal
        if(index < 0){
          return true;
        }
      }
    },
    methods: {
      addToCart () {
        this.productItem._id = this.productItem.product_item_id;
        //config qty if not set
        if(this.productItem.product_item_order_quantity == undefined){
          this.productItem.product_item_order_quantity = 1;
        }
        this.productItem.product_main_id = this.productMain.product_id;
        this.productItem.product_business = this.productMain.product_business_ownername;
        this.productItem.product_name = this.productMain.product_name;
        this.productItem.product_url = this.productMain.product_business_ownername+"/"+this.productMain.product_url_name;
        this.productItem.product_item_quantity = this.productItem.product_item_quantity;
        //some settings 
        //for product items images
        if((this.productItemGroup.product_item_group_is_color_image == 'IMG') && (this.productItemGroup.product_item_group_image != 'error')){
          this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
        }else{ //is color or error
          this.productItem.product_item_image = '';
        }
        //for product_shipping_calculation_method
        this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;
        //../some settings 

        this.$store.commit(ADD_TO_CART, this.productItem)
      },
      // removeFromCart (id) {
      //   this.$store.commit(REMOVE_FROM_CART, id)
      // },
      removeFromCart (payload) {
        this.$store.commit(REMOVE_FROM_CART, payload)
      },
      redir(rlink){
            location.replace("/"+rlink)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// ProductCartActions.vue?e791d3f2